// extracted by mini-css-extract-plugin
export default {"otp-input":"OtpCodeInput_otp-input__Y17cv"};